export enum Criteria {
  Equals = 1,
  Contains = 2,
}

export type Filter = {
  fieldName: string;
  filterCriteria: Criteria;
  matches: (string | number)[];
};

export enum SortType {
  Desk = -1,
  Ask = 1,
}

export type PageParams = {
  pageNumber: number;
  pageSize: number;
  sortFieldName: string;
  sortDirection: SortType;
  filters?: Filter[];
};
